/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from "react";
import { useWindowResize } from "utils/hooks";
import Image from "next/image";
import { IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB, JOB_STATUS } from "utils/constants";
import { isUserLoggedIn } from "utils";
import { CircularProgress } from "@material-ui/core";
import { ToastContext } from "context/Toast/ToastContext";
import ExternalLinkIcon from "assets/svgs/ExternalLinkIcon";
import { externalJobApplyCTA, getUrlPath } from "utils/helpers";
import clsx from "clsx";
import WorkFromHomeIcon from "components/RevampFeedDetails/assets/JobCardIcons/WorkFromHomeIcon";
import CompanyImagePlaceholderIcon from "components/RevampFeedDetails/assets/ComapnyImagePlaceholderIcon";
import { USER_PLATFORM } from "constants/tracking";
import JobCardTags from "components/RevampFeedDetails/common/components/JobCardTags";
import InfoIcon from "../../../assets/InfoIcon";
import CashSalaryIcon from "../../../assets/CashSalaryIcon";
import LocationPinIcon from "../../../assets/LocationPinIcon";
import CashSalaryMobileIcon from "../../../assets/CashSalaryMobileIcon";
import ShareIcon from "../../../assets/ShareIcon";

const JobDetailsCard = ({
	jobDetails,
	jobApplicationMode,
	isJobApplied,
	applyLink,
	isExternalJobApplied,
	pageName,
	isLoadingJobApply,
	handleApplyButtonClick,
	isAppliedJobDetailsLoading,
}) => {
	const [isMobileView] = useWindowResize();

	const isExternalJob = jobDetails?.is_external_job;
	const isWalkInJob = jobDetails?.is_walk_in;

	// const { handleOpenToast } = useContext(ToastContext);
	const isExpiredJob = jobDetails.status !== JOB_STATUS.ACTIVE;

	const renderApplyButtonText = () => {
		if (isLoadingJobApply || isAppliedJobDetailsLoading) {
			return (
				<div className="flex w-full items-center justify-center">
					<CircularProgress color="inherit" size={25} />
				</div>
			);
		}
		if (!isJobApplied && isExternalJob) {
			return (
				<div className="flex w-full cursor-pointer items-center justify-center space-x-[4px]">
					{externalJobApplyCTA(jobDetails)}
				</div>
			);
		}
		if (isJobApplied) {
			return (
				<div className="flex w-full cursor-pointer items-center justify-center space-x-[4px]">
					<p className="m-0 whitespace-nowrap text-center text-sm">Applied</p>
				</div>
			);
		}
		if (!isJobApplied && !isExternalJob) {
			if (isWalkInJob) {
				return <>Register for walk-in</>;
			}
			return (
				<div className="flex w-full cursor-pointer items-center justify-center space-x-[4px]">
					<p className="m-0 whitespace-nowrap text-center text-sm">
						Apply for job
					</p>
				</div>
			);
		}
		return "";
	};

	const handleApplyClick = async () => {
		const { default: Mixpanel } = await import("utils/Mixpanel");

		Mixpanel.track("Apply Now Button Clicked", {
			page: getUrlPath(),
			"Job ID": jobDetails.id,
			JobTitle: jobDetails?.title,
			area: jobDetails?.address?.area,
			city: jobDetails?.address?.city?.name,
			maxSalary: jobDetails?.max_salary,
			minSalary: jobDetails?.min_salary,
			"Job Board Type": jobDetails?.is_external_job ? "Non Apna Job" : "Apna Job",
			earning_potential: jobDetails?.earning_potential,
			is_wfh: jobDetails?.is_wfh,
			Job_company_name: jobDetails?.organization?.name,
			tags_shown: jobDetails?.ui_tags?.map((tag) => tag?.text),
		});
		if (!isUserLoggedIn()) {
			localStorage?.setItem(IS_APPLY_BUTTON_CLICKED_EXTERNAL_JOB, "true");
		}
	};
	const renderSalaryString = () => {
		if (isExternalJob) {
			return jobDetails?.salary_detail || "Not disclosed";
		}
		if (
			jobDetails?.is_incentives_involved &&
			jobDetails?.salary_type === 2 &&
			jobDetails?.earning_potential
		) {
			return `₹${jobDetails?.earning_potential?.toLocaleString()} monthly*`;
		}
		if (
			jobDetails?.is_incentives_involved &&
			(jobDetails?.min_salary || jobDetails?.min_salary === 0) &&
			jobDetails?.earning_potential
		) {
			return `₹${jobDetails?.min_salary?.toLocaleString()} - ₹${jobDetails?.earning_potential?.toLocaleString()} monthly*`;
		}

		if (
			(jobDetails?.min_salary || jobDetails?.min_salary === 0) &&
			jobDetails?.earning_potential
		)
			return `₹${jobDetails?.min_salary?.toLocaleString()} - ₹${jobDetails?.earning_potential?.toLocaleString()} monthly`;

		return "";
	};
	const renderApplyButtonSection = () => {
		if (jobApplicationMode?.mode === "throttled") {
			return "";
		}
		if (
			jobDetails?.status === JOB_STATUS.ACTIVE &&
			(jobApplicationMode || !isUserLoggedIn())
		) {
			return (
				<div
					className={clsx(
						"w-full cursor-pointer rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white",
						{
							"bg-[#B8B0B9] opacity-50":
								isJobApplied || (isExternalJob && isExternalJobApplied),
						}
					)}
					onClick={handleApplyButtonClick}
				>
					{!isExternalJobApplied && renderApplyButtonText()}
					{isExternalJob && isExternalJobApplied && <>Applied</>}
				</div>
			);
		}
		return (
			<div
				className={clsx(
					"w-full rounded border border-solid bg-[#1F8268] px-[16px] py-[8px] text-center font-semibold text-white",
					{
						"bg-[#B8B0B9] opacity-50":
							isJobApplied || (isExternalJob && isExternalJobApplied),
					}
				)}
				onClick={handleApplyButtonClick}
			>
				{!isExternalJobApplied && renderApplyButtonText()}
				{isExternalJob && isExternalJobApplied && <>Applied</>}
			</div>
		);
	};
	const sharetext = `Hey! I found a ${jobDetails?.title} job on apna. check it out here 👇`;

	const commonTrackingObj = {
		jobId: jobDetails?.id,
		Source: pageName,
		"Job Title": jobDetails?.title,
		"Min Salary": jobDetails?.min_salary,
		"Max Salary": jobDetails.max_salary,
		Area: jobDetails?.address?.area,
		City: jobDetails?.address?.city?.name,
		page: getUrlPath(),
		category: jobDetails?.category_slug,
		userPlatform: USER_PLATFORM.apna,
	};

	const trackingEvent = (eventName, cta, userInfo = {}) => {
		import("utils/Mixpanel").then((Mixpanel) =>
			Mixpanel.default.track(eventName, {
				...commonTrackingObj,
				cta,
				...userInfo,
			})
		);
	};

	const shareWhatsApp = (e) => {
		e.preventDefault();
		e.stopPropagation();
		trackingEvent("Web Job shared click", "Share Job");
		const isMobile = /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
		const whatsAppbaseUrl = `https://${isMobile ? "api" : "web"}.whatsapp.com/send`;
		const shareUrl = `${whatsAppbaseUrl}?text=${encodeURIComponent(
			`${sharetext}\n ${jobDetails.public_url}?utm_source=whatsapp&utm_campaign=joblistingpage`
		)}`;
		window.open(shareUrl, "_blank");
	};

	return (
		<div className="rounded-0 space-y-[12px] bg-white p-[16px] pt-[16px] md:w-full md:max-w-[690px] md:rounded-xl md:border md:border-solid md:pt-[16px]">
			{/* Logo, title and name */}
			<div className="mb-[4px] flex gap-[12px]">
				{jobDetails?.organization?.logo_url ? (
					<div className="h-[48px] w-[48px]">
						<Image
							height="48px"
							width="48px"
							layout="fixed"
							src={jobDetails?.organization?.logo_url}
							className="rounded object-contain"
						/>
					</div>
				) : (
					<div className="block h-[48px] w-[48px] [&>svg]:h-[48px] [&>svg]:w-[48px]">
						<CompanyImagePlaceholderIcon />
					</div>
				)}
				<div>
					<p className="m-0 truncate text-wrap text-md font-semibold text-[#190A28]">
						{jobDetails?.title}
					</p>
					<p className="m-0 text-sm text-[#8C8594]">
						{jobDetails?.organization?.name}
					</p>
				</div>
			</div>
			{/* Location and Salary */}
			<div className="my-[12px] md:my-0 md:flex md:flex-row md:items-center md:justify-between">
				{jobDetails?.is_wfh ? (
					<div className="flex items-center gap-[8px]">
						<div className="flex h-[20px] w-[20px] items-center justify-center md:[&>svg]:h-[20px] md:[&>svg]:w-[20px]">
							<WorkFromHomeIcon />
						</div>
						<p className="m-0 text-sm text-[#8C8594]">Work from home</p>
					</div>
				) : (
					<div className="flex items-center gap-[8px]">
						<div className="flex h-[20px] w-[20px] items-center justify-center">
							<LocationPinIcon />
						</div>
						<p className="m-0 truncate text-sm text-[#8C8594]">
							{jobDetails?.location_name}
						</p>
					</div>
				)}

				{renderSalaryString() && (
					<div className="mt-2 flex items-center gap-[8px] md:mt-0">
						<div className="flex h-[20px] w-[20px] items-center justify-center">
							{isMobileView ? <CashSalaryMobileIcon /> : <CashSalaryIcon />}
						</div>
						<p className="m-0 text-sm text-[#8C8594]">
							{renderSalaryString()}
						</p>
					</div>
				)}
			</div>
			{/* Remuneration info */}
			{!isExternalJob && (
				<div className="rounded-lg bg-[#edebee80] px-[16px] py-[12px]">
					<div className="md:grid md:grid-cols-3">
						{jobDetails?.salary_type !== 2 && (
							<div className="flex justify-between md:flex-col md:gap-[8px]">
								<p className="m-0 text-xs text-[#8C8594]">Fixed</p>
								<p className="m-0 flex items-center text-xs font-semibold text-[#8C8594]">
									₹{jobDetails?.fixed_min_salary} - ₹
									{jobDetails?.fixed_max_salary}
								</p>
							</div>
						)}
						{jobDetails?.salary_type !== 2 && (
							<div className="my-[12px] h-[1px] w-full bg-[#8C8594] opacity-20 md:hidden" />
						)}
						{jobDetails?.salary_incentive > 0 && (
							<>
								<div className="flex justify-between md:flex-col md:gap-[8px]">
									<p className="m-0 text-xs text-[#8C8594]">
										Average Incentives
										{jobDetails?.is_incentives_involved && (
											<span>*</span>
										)}
									</p>
									<p className="m-0 text-xs font-semibold text-[#8C8594]">
										₹{jobDetails?.salary_incentive?.toLocaleString()}
									</p>
								</div>
								<div className="my-[12px] h-[1px] w-full bg-[#8C8594] opacity-20 md:hidden" />
							</>
						)}
						<div className="flex justify-between md:flex-col md:gap-[8px]">
							<p className="m-0 text-xs text-[#8C8594]">
								Earning Potential
							</p>
							<p className="m-0 text-xs font-semibold text-[#8C8594]">
								₹{jobDetails?.earning_potential?.toLocaleString()}
							</p>
						</div>
					</div>
					{jobDetails?.is_incentives_involved && (
						<>
							<div className="my-[6px] h-[1px] w-full opacity-20 md:my-[12px] md:block md:bg-[#8C8594]" />
							<div className="flex items-center space-x-[4px]">
								<div className="[md:py-0 &>svg]:h-[16px] py-[4px] [&>svg]:w-[16px]">
									<InfoIcon />
								</div>
								<p className="text-[#8C8594 m-0 text-xs">
									You can earn more incentive if you perform well
								</p>
							</div>
						</>
					)}
				</div>
			)}
			<JobCardTags tags={jobDetails?.ui_tags} />
			{!isMobileView &&
				!isExpiredJob &&
				jobApplicationMode?.mode !== "throttled" && (
					<div className="flex w-full items-center gap-[16px] text-sm">
						<div className="w-full">{renderApplyButtonSection()}</div>
						<div
							className="flex cursor-pointer items-center gap-1 rounded border border-solid border-[#1F8268] px-[16px] py-[8px] font-semibold text-[#1F8268]"
							onClick={shareWhatsApp}
						>
							<ShareIcon />
							Share
						</div>
					</div>
				)}
			{!isMobileView && isExpiredJob && (
				<div className="flex items-center gap-[8px] rounded-lg bg-[#FBECED] px-[12px] py-[8px]">
					<InfoIcon fill="#CC0000" size={24} />
					<p className="m-0 text-md leading-[24px] text-[#CC0000]">
						This job has expired
					</p>
				</div>
			)}
		</div>
	);
};

export default JobDetailsCard;
